<template>
  <div class="EsharedDet" >
    <div class="centered-div">
      <div v-show="divOff">
        <el-form ref="form" :model="shareForm" label-width="0px" class="form">
          <el-row>
            <el-col :span="24">
              <div class="logo-top">
                <div class="logo-box">
                  <img class="logo" :src="imgLogo" />
                  <span class="logoTitle">迈思普电子股份有限公司</span>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="" prop="eshared_password">
                <el-input v-model="shareForm.eshared_password" style="width: 285px" placeholder="输入提取码 不区分大小写" maxlength="4" :disabled="off" v-show="formOff === 'Y'"></el-input>
                <span style="font-size: 18px;color: red;margin: 0px 0px 0px 48px;" v-show="formOff === 'N'">
                  链接错误,请复制正确链接
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-button v-show="formOff === 'Y'" size="mini" type="primary" @click="shareFromClick()" style="margin: 0px 0px 0px 205px" :disabled="off">提取文件</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div>
      </div>
    </div>
    <div v-show="tableOff" class="centered-div2" style="width: 700px;">
      <el-row>
        <div class="logo-top">
          <div class="logo-box">
            <img style="width: 85px;height: 65px" :src="imgLogo" />
            <el-row>
              <el-col>
                <span style="height: 30px;line-height: 36px;font-size: 18px;font-weight: bolder;padding-left: 15px;">迈思普电子股份有限公司</span>
              </el-col>
              <el-col>
                <span style="font-size: 15px;margin: 0px 0px 0px 20px;">文件分享系统</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-row>
      <el-row>
        <el-card style="width: 100%">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="2">
                <i class="el-icon-s-custom" style="font-size: 35px;"></i>
              </el-col>
              <el-col :span="22">
                <el-row>
                  <el-col :span="16">
                    <span style="font-size: 14px;font-weight: bolder;">{{this.listData.eshare_crt_by_name}}的分享</span>
                  </el-col>
                  <el-col :span="8">
                    <span style="font-size: 14px;font-weight: bolder;">共{{this.listData.size}}个文件,{{this.listData.eshared_valid}}小时有效</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col  :span="16">
                    <span style="font-size: 11px;">分享缘由：{{this.listData.eshare_reason}}</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-table :data="esharedData" :height="tableHeight" size="mini"
                    :header-cell-style="{textAlign:'center', backgroundColor: '#FFFFFF', color: '#CFCFCF', fontSize: '15px', height: '30px'}" >
            <el-table-column label="图标" width="70px" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <icon :name="efileIcon(scope.row)" :style="{color: efileIconColor(scope.row), height: 35 + 'px'}" class="efileIconDiv" ></icon>
              </template>
            </el-table-column>
            <el-table-column prop="mhfiles_file_dname" label="文件名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fileSize" width="80px" label="大小" align="center"></el-table-column>
            <el-table-column label="操作" width="120px" align="center">
              <template slot-scope="scope">
                <el-button v-show="scope.row.off !== 'Y'"
                           size="mini" round icon="el-icon-download"
                           @click="getFile(scope.row, 'B')" >下载</el-button>
                <el-progress
                  v-show="scope.row.off === 'Y'"
                  :percentage="scope.row.downloadPercent || 0"
                  style="margin-bottom: 5px;">
                </el-progress>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div style="height: 20px"></div>
        <el-row>
          <el-col :span="4" :offset="2">
            <span>分享日期</span>
          </el-col>
          <el-col :span="6">
            <span>{{timestampToTime2(this.listData.eshare_date)}}</span>
          </el-col>
          <el-col :span="4" :offset="1">
            <span>有效日期</span>
          </el-col>
          <el-col :span="6">
            <span>{{timestampToTime2(this.listData.eshared_beg_date)}}</span>
          </el-col>
        </el-row>
        <div style="height: 20px"></div>
        <el-row>
          <el-col :span="6" :offset="9">
            <el-statistic class="title"
              ref="statistic"
              format="HH:mm:ss"
              :value="this.listData.eshared_beg_date"
              title="距离失效"
              time-indices>
            </el-statistic>
          </el-col>
        </el-row>
      </el-row>
    </div>
    <div class="login-bottom">
      <el-button type="text" disabled>Copyright © 2023-2025 迈思普电子股份有限公司 版权所有</el-button>
      <el-button type="text" disabled>粤ICP备18058470号-1</el-button>
    </div>
  </div>
</template>

<script>
import EditBase from '@/components/form/EditBase.vue'
// import EditSlot from '@/components/form/EditSlot.vue'
// import TableColumn from '@/components/base/TableColumn.vue'
// import FormItem from '@/components/base/FormItem.vue'
export default {
  name: 'EsharedDet',
  mixins: [EditBase],
  data () {
    return {
      pageType: 'BASE',
      mainPostUrl: {
        queryUrl: '',
        postUrl: ''
      },
      mainObjectProps: {},
      mainRules: {},
      mainColumns: [],
      detPostUrl: {
        queryUrl: '',
        postUrl: ''
      },
      detObjectProps: {},
      detRules: {},
      detColumns: [],
      defaultQuery: [],
      queryColumns: [],
      fromData: {
        pod_status: ''
      },
      connectFromRules: {
        radio: [
          { required: true, message: '不能为空！', trigger: 'blur' }
        ]
      },
      connectVisible: false,
      connectForm: {
        radio: 24
      },
      configMap: {},
      shareForm: {
        eshared_url: '',
        eshared_password: ''
      },
      esharedData: [],
      tableHeight: window.innerHeight - 550,
      para: {},
      off: false,
      tableOff: false,
      divOff: true,
      imgLogo: require('../../assets/photo/loginlogo.png'),
      formOff: '',
      oldCode: '',
      listData: {}
    }
  },
  components: {
    // TableColumn,
    // FormItem,
    // EditSlot
  },
  methods: {
    shareFromClick: async function () {
      // 校验
      await this.getChk()
      if (this.para.code === '') {
        await this.$confirm('提取失败!链接错误，请复制完整链接, 请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } else {
        if (this.shareForm.eshared_password === '') {
          await this.$confirm('请输入提取码, 请确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          // 调用提取
          const para = {
            eshared_code: this.para.code,
            password: this.shareForm.eshared_password,
            flag: 0,
            msg: ''
          }
          const { data: res } = await this.$http.post('/edoc/setEsharedDetChk', para)
          if (res.data.flag === -1) {
            // 执行查询
            await this.getTableData()
          } else {
            await this.$confirm(res.data.msg + '请确认', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
          }
        }
      }
    },
    getTableData: async function () {
      const that = this
      this.tableOff = true
      this.divOff = false
      const para = {
        eshared_code: this.para.code
      }
      const { data: res } = await that.$http.post('/edoc/getEsharedDetByNbrList', para)
      if (res.data.length > 0) {
        this.esharedData = res.data
        this.listData = res.data[0]
      } else {
        await this.$confirm('提取失败!数据失效, 请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }
    },
    NE (msg, fixed = false) {
      // 默认为4500关闭
      const duration = (fixed) ? 0 : 4500
      this.$notify.info({
        title: '成功',
        message: msg,
        duration: duration,
        offset: 100
      })
    },
    async getFile (row, type) {
      const that = this
      await this.getChk()
      const para = {
        eshared_code: this.para.code,
        mhfiles_file_dname: row.mhfiles_file_dname,
        mhfiles_file_path: row.mhfiles_file_path
      }
      await that.$http.post('/edoc/setEshareLog', para)
      if (this.tableOff) {
        if (type === 'B') {
          that.$set(row, 'off', 'Y')
          that.$set(row, 'downloadPercent', 0)
          const p = {
            rootDirCode: 'SYSCFG_EDOC',
            rootDirField: 'sys_char2',
            filePath: row.mhfiles_file_path,
            // filePath: '\\SCMGRN.xlsx',
            fileName: row.mhfiles_file_dname,
            showFileName: row.mhfiles_file_dname,
            reConvert: false
          }
          const url = '/edoc/responseEdocFile'
          that.$http.post(url, p, {
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                const percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                // 更新当前行的下载进度
                that.$set(row, 'downloadPercent', percentComplete)
                if (percentComplete >= 100) {
                  that.$set(row, 'off', 'N')
                  this.NE('下载成功！')
                }
              }
            }
          }).then((response) => {
            const content = response.data
            const blob = new Blob([content])
            const aLink = document.createElement('a')
            const url = URL.createObjectURL(blob)
            if ('download' in aLink) {
              aLink.download = p.showFileName
              aLink.style.display = 'none'
              aLink.href = url
              document.body.appendChild(aLink)
              aLink.click()
              URL.revokeObjectURL(aLink.href)
              document.body.removeChild(aLink)
            } else {
              navigator.msSaveBlob(blob, p.showFileName)
            }
          })
        }
      }
    },
    async sleep (n) {
      const start = new Date().getTime()
      while (true) {
        if (new Date().getTime() - start > n) {
          break
        }
      }
    },
    efileIcon (row) {
      const newName = row.mhfiles_file_dname
      const suffix = newName.substring(newName.lastIndexOf('.') + 1)
      if (suffix.toUpperCase() === 'PDF') {
        return 'file-pdf'
      } else if ((suffix.toUpperCase() === 'XLS') || (suffix.toUpperCase() === 'XLSX')) {
        return 'file-excel'
      } else if ((suffix.toUpperCase() === 'DOC') || (suffix.toUpperCase() === 'DOCX')) {
        return 'file-word'
      } else if ((suffix.toUpperCase() === 'PPT') || (suffix.toUpperCase() === 'PPTX')) {
        return 'file-powerpoint'
      } else if ((suffix.toUpperCase() === 'JPG') || (suffix.toUpperCase() === 'BMP') || (suffix.toUpperCase() === 'PNG') || (suffix.toUpperCase() === 'JPEG')) {
        return 'file-image'
      } else {
        return 'file'
      }
    },
    efileIconColor (row) {
      const newName = row.mhfiles_file_path
      const suffix = newName.substring(newName.lastIndexOf('.') + 1)
      if (suffix.toUpperCase() === 'PDF') {
        return '#FF1E1E'
      } else if ((suffix.toUpperCase() === 'XLS') || (suffix.toUpperCase() === 'XLSX')) {
        return '#34C724'
      } else if ((suffix.toUpperCase() === 'DOC') || (suffix.toUpperCase() === 'DOCX')) {
        return '#3370FF'
      } else if ((suffix.toUpperCase() === 'PPT') || (suffix.toUpperCase() === 'PPTX')) {
        return '#EC6810'
      } else if ((suffix.toUpperCase() === 'JPG') || (suffix.toUpperCase() === 'BMP') || (suffix.toUpperCase() === 'PNG') || (suffix.toUpperCase() === 'JPEG')) {
        return ''
      } else {
        return ''
      }
    },
    getChk: async function () {
      this.para = this.$route.query
      const that = this
      const para = {
        eshared_code: this.para.code
      }
      const { data: res } = await that.$http.post('/edoc/getEsharedDetByNbr', para)
      if (res.data) {
        if (!res.data.eshared_in_effect) {
          this.off = true
          this.divOff = true
          this.tableOff = false
          this.formOff = 'N'
        } else {
          this.formOff = 'Y'
          this.off = false
        }
      } else {
        this.off = true
        this.divOff = true
        this.tableOff = false
        this.formOff = 'N'
      }
    },
    timestampToTime (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc != null) {
        const date = new Date(daterc)
        const year = date.getFullYear()
        /* 在日期格式中，月份是从0开始，11结束，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        // 拼接
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      }
    },
    timestampToTime2 (row) {
      const daterc = row
      if (daterc != null) {
        const date = new Date(daterc)
        const year = date.getFullYear()
        /* 在日期格式中，月份是从0开始，11结束，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        // 拼接
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      }
    },
    handleResize () {
      this.tableHeight = window.innerHeight - 550
    }
  },
  created () {
    this.getChk()
  },
  mounted () {
    // 组件挂载时立即执行一次，获取初始窗口宽度
    this.handleResize()
    // 监听屏幕宽度和高度变化
    window.addEventListener('resize', this.handleResize, true)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$route' (to, from) {
      this.divOff = true
      this.tableOff = false
      this.shareForm.eshared_password = ''
      this.getChk()
    },
    immediate: true, // 立即执行一次
    deep: true // 深度监听
  }
}
</script>

<style lang="less" scoped>
.EsharedDet {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  height: 100vh;           /* 视口高度 */
}
.centered-div {
  position: absolute; /* 绝对定位 */
  justify-content: center;
  top: 100px;
  //top: 100px;            /* 向上偏移50% */
  //left: 50%;           /* 向左偏移50% */
  //transform: translate(-50%, -50%); /* 向上和向左移动自身宽高的50%，实现居中 */
}
.centered-div2 {
  position: absolute; /* 绝对定位 */
  justify-content: center;
  top: 20px;
  //top: 100px;            /* 向上偏移50% */
  //left: 50%;           /* 向左偏移50% */
  //transform: translate(-50%, -50%); /* 向上和向左移动自身宽高的50%，实现居中 */
}
.efileIconDiv {
  cursor: pointer;
  padding-left: 9px;
  padding-top: 9px;
}
.logo-top {
  .logo-box {
    display: flex;
    opacity: 1;
    .logo {
      width: 50px;
      height: 50px;
    }
    .logoTitle {
      height: 50px;
      line-height: 50px;
      font-size: 20px;
      font-weight: bolder;
      padding-left: 15px;
    }
  }
}
.login-bottom {
  position: absolute;
  bottom: 10px;
  //right: 10%;
  min-width: 360px;
  width: 20%;
  height: 80px;
  padding: 0px 40px;
  text-align: center
}
.custom-header {
  background-color: red; /* 例如，设置为浅灰色 */
}

/deep/ .title {
  color: #e83b3b !important;
  font-size: 18px !important;
  font-weight: bold;
}
/deep/ .number {
  color: #e83b3b !important;
}
</style>
